module.exports = __webpack_public_path__ + "img/nodata.737e0403.png";